import styled from 'styled-components';

import { breakpoint } from 'DesignLibrary/global';

export const Container = styled.div<{ backgroundColor: string; brand: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 16px 16px 0 0;
  padding: 0;
  position: relative;
  width: calc(100% + 2rem);
  margin-left: -1rem;
  margin-top: -1rem;
  min-height: 440px;
  @media (min-width: 992px) {
    padding: 28px 0;
    width: 100%;
    margin-left: auto;
    margin-top: auto;
    border-radius: 16px;
  }
`;

export const TestimonialsWrapper = styled.div<{ brand: string }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 18px;
  @media (min-width: 768px) {
    flex-direction: row;
    width: 100%;
    padding: 26px;
  }
`;

export const Quote = styled.div<{ background: string }>`
  background: ${({ background }) => background};
  position: relative;
  border-radius: 24px 24px 0 24px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 1.1rem 1.25rem;
  opacity: 0;
  animation: fadeSlide 0.8s ease forwards;
  animation-delay: 0.1s;
  &:nth-of-type(2) {
    animation-delay: 0.4s;
  }
  @keyframes fadeSlide {
    from {
      top: -10px;
      opacity: 0;
    }
    to {
      top: 0;
      opacity: 1;
    }
  }
  ${breakpoint.DESKTOP} {
    padding: 1.5rem 1.8rem;
    border-radius: 40px 40px 0 40px;
  }
`;

export const QuoteText = styled.p<{ color: string }>`
  color: ${({ color }) => color};
  text-align: left;
  line-height: 140%;
  font-weight: 400;
`;

export const BoldText = styled.strong`
  font-family: 'Gelica';
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  @media (min-width: 992px) {
    font-size: 16px;
  }
  @media (min-width: 1301px) {
    font-size: 18px;
  }
`;

export const LightText = styled.em`
  display: block;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: -0.011em;
  margin-top: 1rem;
  @media (min-width: 992px) {
    font-size: 14px;
  }
  @media (min-width: 1301px) {
    font-size: 15px;
  }
`;

export const ReplayButton = styled.button<{ brand: string }>`
  position: absolute;
  bottom: 0.5rem;
  left: 10px;
  width: 96px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
  &:active {
    background: rgba(255, 255, 255, 0.65);
  }
`;

export const RepeatImage = styled.img`
  width: 16px;
  height: 16px;
`;

export const CopyText = styled.div`
  color: #2f2f52;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
`;

export const BulbCatWrapper = styled.div`
  position: absolute;
  bottom: 1%;
  right: 5%;
  max-width: 200px;
  width: 25%;
  z-index: 1;
  pointer-events: none;
  @media (min-width: 1024px) {
    width: 30%;
    max-width: 226px;
    bottom: 0;
    left: 120px;
    right: auto;
  }
  img {
    width: 100%;
    display: block;
    margin: 0 auto;
  }
`;

export const BoatGuyWrapper = styled.div`
  position: absolute;
  width: 44%;
  height: 45%;
  bottom: -9%;
  right: -3%;
  @media (min-width: 601px) {
    right: 3%;
    bottom: -4%;
  }
  @media (min-width: 1301px) {
    right: 5%;
    bottom: -2%;
  }
`;
